export const API_BASE_URL = 'https://main.eport.se'
//export const API_BASE_URL = 'https://main.staging.eport.se';
//export const API_BASE_URL = 'http://localhost:50123';